import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const FIELDS = [
  { key: "raison_sociale", label: "Raison sociale" },
  { key: "forme_juridique", label: "Forme juridique" },
  { key: "capital", label: "Capital social" },
  { key: "siret", label: "SIRET" },
  { key: "rcs", label: "RCS" },
  { key: "tva", label: "N° TVA intracommunautaire" },
  { key: "orias", label: "Immatriculation ORIAS" },
  { key: "adresse", label: "Adresse" },
  { key: "telephone", label: "Téléphone" },
  { key: "email", label: "Email" },
  { key: "directeur_publication", label: "Directeur de la publication" },
  { key: "hebergeur", label: "Hébergeur" },
];

export default function MentionsLegales() {
  const [data, setData] = useState({});
  useEffect(() => { api.get("/legal").then((r) => setData(r.data || {})); }, []);

  return (
    <div data-testid="page-legal">
      <section className="relative py-24 md:py-28 border-b border-ducs-gold/10">
        <div className="relative max-w-5xl mx-auto px-5 md:px-8">
          <div className="label-caps mb-5">Mentions légales</div>
          <h1 className="font-serif text-4xl sm:text-5xl text-ducs-cream leading-tight">
            Informations légales
          </h1>
          <div className="gold-divider mt-6" />
        </div>
      </section>
      <section className="py-16 md:py-24">
        <div className="max-w-5xl mx-auto px-5 md:px-8 space-y-10">
          <div className="grid sm:grid-cols-2 gap-x-10 gap-y-5">
            {FIELDS.map((f) => (
              <div key={f.key} className="border-b border-ducs-gold/15 pb-3">
                <div className="label-caps mb-1">{f.label}</div>
                <div className="text-ducs-cream/90 text-sm">
                  {data?.[f.key] || <span className="text-ducs-mist/60">À compléter</span>}
                </div>
              </div>
            ))}
          </div>

          {data?.custom_text && (
            <div className="prose prose-invert max-w-none">
              <div className="label-caps mb-3">Informations complémentaires</div>
              <p className="text-ducs-cream/85 leading-relaxed whitespace-pre-line">{data.custom_text}</p>
            </div>
          )}

          <div className="text-xs text-ducs-mist leading-relaxed border-t border-ducs-gold/15 pt-6">
            <p>
              Les présentes mentions légales sont susceptibles d'évoluer. Pour toute
              demande relative aux données personnelles ou à l'usage du site, vous
              pouvez nous écrire à l'adresse email indiquée ci-dessus.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
